const FilmData = {
  films: [
    {
      name: 'Feature Films',
      subtitle: '',
      vids: [
        {
          title: 'ANOTHER CABIN IN THE WOODS MOVIE',
          text: 'In this tongue-in-cheek spoof, horror-savvy characters travel to an isolated wedding event and get trapped in yet another cabin in the woods, where they are forced to navigate murder, mystery, and red herrings to uncover who will stop at nothing for their twisted happily ever after.<br/>Directed by: Joe Bandelli<br/>Written & Produced by: Joe Bandelli, Matthew Wise, & Nick Landa',
          image: '/assets/thumbs/ACITWM_VideoThumbnail.jpg',
          url: 'https://www.primevideo.com/detail/Another-Cabin-In-The-Woods-Movie/0P3N7ZPY3LBYT5H77YR1NK8GVD',
        },
        {
          title: 'HELL HOUSE LLC ORIGINS: THE CARMICHAEL MANOR',
          text: 'Internet sleuths travel to Carmichael Manor, site of the 1989 Carmichael family murders. After four nights, the group was never heard from again. What is discovered on their footage is even more disturbing than anything found on the Hell House tapes.<br/>Directed by: Stephen Cognetti<br/>Produced by: Joe Bandelli',
          image: '/assets/thumbs/HH4.png',
          url: 'https://www.shudder.com/movies/watch/hell-house-llc-origins-the-carmichael-manor/603eac069b74403c',
        },
        {
          title: 'UNKNOWN DIMENSION: THE STORY OF PARANORMAL ACTIVITY',
          text: 'A deep dive into the making of the "Paranormal Activity" films with first time ever interviews with cast and crew, never-before-seen footage from the movies, and a preview of the seventh installment of the franchise: "Paranormal Activity: Next of Kin." <br/>Written & Directed by: Joe Bandelli<br/>Produced by: MasiMedia & Candy Heart Productions',
          image: '/assets/thumbs/unknown-dimension-layred-horizontal.jpg',
          url: 'https://www.paramountmovies.com/movies/unknown-dimension-the-story-of-paranormal-activity',
        },
        {
          title: 'HELL HOUSE LLC 3: LAKE OF FIRE',
          text: 'A year after the disappearance of The Morning Mysteries guests, Russell Wynn invites a crew to film inside The Abaddon Hotel, leading up to the opening of his show, Insomnia. They soon encounter a more nefarious plot that threatens to unleash hell on earth. <br/>Directed by: Stephen Cognetti <br/>Produced by: Joe Bandelli',
          image: '/assets/thumbs/hh3thumbnail.jpg',
          url: 'https://www.amazon.com/Hell-House-LLC-Lake-Fire/dp/B0831TTWRK/ref=sr_1_2?crid=13E1LM1BJT5XU&keywords=hell+house+llc+two&qid=1697857762&s=instant-video&sprefix=hell+house+llc+two%2Cinstant-video%2C144&sr=1-2',
        },
        {
          title: 'HELL HOUSE LLC 2: THE ABADDON HOTEL',
          text: 'Eight years following the tragic events at the Abaddon Hotel, an investigative news team went searching for answers. The truth was more terrifying than they ever imagined in this second installment of the found footage horror franchise: "Hell House LLC". <br/>Directed by: Stephen Cognetti <br/>Produced by: Joe Bandelli',
          image: '/assets/thumbs/HellHouse2.jpg',
          url: 'https://www.amazon.com/Hell-House-LLC-II-Abaddon/dp/B07HJV4RRR/ref=sr_1_3?crid=13E1LM1BJT5XU&keywords=hell+house+llc+two&qid=1697857762&s=instant-video&sprefix=hell+house+llc+two%2Cinstant-video%2C144&sr=1-3',
        },
        {
          title: 'Hell House LLC',
          text: 'Five years after an unexplained malfunction causes the death of 15 tour-goers and staff on the opening night of a Halloween haunted house tour, a documentary crew travels back to the scene of the tragedy to find out what really happened. <br/>Directed by: Stephen Cognetti<br/>Produced by: Joe Bandelli',
          image: '/assets/thumbs/HellHouseLLC.jpg',
          url: 'https://www.amazon.com/Hell-House-Kristin-Michelle-Taylor/dp/B07WZH8ZLH/ref=sr_1_4?crid=13E1LM1BJT5XU&keywords=hell+house+llc+two&qid=1697857762&s=instant-video&sprefix=hell+house+llc+two%2Cinstant-video%2C144&sr=1-4',
        },
      ],
    },
    {
      name: 'Web Series',
      subtitle: '',
      vids: [
        {
          title: 'Tuesday Nights: Episode 1',
          text: 'Woman heads to her divorce attorney\'s office to sign her divorce papers and prepares for her date later that evening.<br/>Directed by: Joe Bandelli<br/>Produced by: Joe Bandelli & Shiva Kalaiselvan',
          image: '/assets/thumbs/TN1.jpg',
          url: 'https://vimeo.com/309308384',
        },
        {
          title: 'Tuesday Nights: Episode 2',
          text: 'Woman meets with her Father in the park to inform him of her divorce and her date.<br/>Directed by: Joe Bandelli<br/>Produced by: Joe Bandelli & Shiva Kalaiselvan',
          image: '/assets/thumbs/TN2.jpg',
          url: 'https://vimeo.com/309318674',
        },
        {
          title: 'Tuesday Nights: Episode 3',
          text: 'Woman asks her Friend to come help remove some of her Ex-Husband\'s things, while she prepares for her date. <br/>Directed by: Joe Bandelli<br/>Produced by: Joe Bandelli & Shiva Kalaiselvan',
          image: '/assets/thumbs/TN3.jpg',
          url: 'https://vimeo.com/309331435',
        },
        {
          title: 'Tuesday Nights: Episode 4',
          text: 'Woman makes an emotional stand when her Ex-Husband unexpectedly shows up at her apartment, asking for a second chance.<br/>Directed by: Joe Bandelli<br/>Produced by: Joe Bandelli & Shiva Kalaiselvan',
          image: '/assets/thumbs/TN4.jpg',
          url: 'https://vimeo.com/309338508',
        },
        {
          title: 'Tuesday Nights: Episode 5',
          text: 'Woman goes out to dinner with her highly anticipated Date and decides to take him home that evening.<br/>Directed by: Joe Bandelli<br/>Produced by: Joe Bandelli & Shiva Kalaiselvan',
          image: '/assets/thumbs/TN5.jpg',
          url: 'https://vimeo.com/309742552',
        },
        {
          title: 'Tuesday Nights: Episode 6',
          text: 'We discover the mystery behind the Woman\'s Date as her adventure comes to a conclusion.<br/>Directed by: Joe Bandelli<br/>Produced by: Joe Bandelli & Shiva Kalaiselvan',
          image: '/assets/thumbs/TN6.jpg',
          url: 'https://vimeo.com/309748786',
        },
        {
          title: 'Bumbloods Ep1: Saving Grace',
          text: 'After returning home from work and noticing that the streets are overrun by zombies, Jerms enlists Krepe&apos;s help to rescue his girlfriend Grace.<br/>Directed by: Joe Bandelli<br/>Produced by: Joe Bandelli & Matthew Wise',
          image: '/assets/thumbs/bumbloods-thumb1.jpg',
          url: 'https://www.youtube.com/embed/66v8-Z4fX8I',
        },
        {
          title: "Bumbloods Ep2: Three's Company",
          text: 'After watching a shocking speech given by The President of the United States, Krepe shows Jerms something hidden in their third roommate&apos;s room.<br/>Directed by: Joe Bandelli<br/>Produced by: Joe Bandelli & Matthew Wise',
          image: '/assets/thumbs/bumbloods-thumb2.jpg',
          url: 'https://www.youtube.com/embed/VpGaANUWpXE',
        },
        {
          title: 'Bumbloods Ep3: Just Shoot Me',
          text: 'Jerms approaches Krepe with a plan to escape the city and save their lives. <br/>Directed by: Joe Bandelli<br/>Produced by: Joe Bandelli & Matthew Wise',
          image: '/assets/thumbs/bumbloods-thumb3.jpg',
          url: 'https://www.youtube.com/embed/wfeZLRG0UAU',
        },
        {
          title: "Bumbloods Ep4: Are You Afraid Of The Dark?",
          text: 'With the horde on their tails, Jerms and Krepe head back to their apartment, but run into a little problem along the way, in the final episode of Season 1.<br/>Directed by: Joe Bandelli<br/>Produced by: Joe Bandelli & Matthew Wise',
          image: '/assets/thumbs/bumbloods-thumb4.jpg',
          url: 'https://www.youtube.com/embed/DvqRM2083q0',
        },
      ],
    },
    {
      name: 'Pilots',
      subtitle: '',
      vids: [
        {
          title: 'Let\'s Get Cereal',
          text: 'Take a trip down memory lane and enjoy a big bowl of cereal with special guest Fiona Dourif to learn about her childhood and find out the moments that made her the person she is today, in the pilot episode of Syfy\'s 90\'s nostalgic variety show, "Let\'s Get Cereal."<br/>Created by: Joe Bandelli<br/>Produced by: Joe Bandelli and Erin LoCascio',
          image: '/assets/thumbs/cereal-thumb.jpg',
          url: 'https://www.youtube.com/watch?v=14tXzfUcJac',
        },
        {
          title: 'Getting Wet',
          text: 'A clip from the pitch pilot for the television series about a guy who must drink to turn it all around.<br/>Directed by: Joe Bandelli<br/>Produced by: Joe Bandelli & Brian Ish',
          image: '/assets/thumbs/GettingWet.jpg',
          url: 'https://vimeo.com/26654530',
        }
      ]
    },
    {
      name: 'Sketch Comedy',
      subtitle: '',
      vids: [
        {
          title: 'Get Hype',
          text: 'A parody of an infomercial for a product that will improve your everyday life.<br/>Directed by: Joe Bandelli<br/>Produced by: The Shorts Show',
          image: '/assets/thumbs/GetHype.jpg',
          url: 'https://player.vimeo.com/video/36356900',
        },
        {
          title: 'Peeling Off The Pounds With Buffalo Bill',
          text: 'Want to work out with a psychopathic serial killer who loves cutting up hefty women?<br/>Directed by: Joe Bandelli<br/>Produced by: The Shorts Show',
          image: '/assets/thumbs/BuffaloBill.jpg',
          url: 'https://player.vimeo.com/video/36324177',
        },
        {
          title: 'Guns Money Hip Hop',
          text: 'The action movie event of the summer. &quot;When one Man is pulled back to the world of crime, there are only three things that matter...&quot;<br/>Directed by: Nick Snow<br/>Produced by: Joe Bandelli',
          image: '/assets/thumbs/GunsMoneyHipHop.jpg',
          url: 'https://www.youtube.com/embed/esvs7cMKJGg',
        },
        {
          title: 'Phone F*ckers',
          text: 'Ever want to try one of those phone sex hotlines? Well sometimes, they can go just a little too far. <br/>Directed by: Lexan Rosser <br/>Produced by: Joe Bandelli',
          image: '/assets/thumbs/PhoneFuckers.jpg',
          url: 'https://vimeo.com/36318792',
        },
        {
          title: 'Support A.C.T.O.R.S.',
          text: 'A parody on the Sarah McLachlan A.S.P.C.A. video. Starring Adam Schneider.<br/>Directed by: Joe Bandelli<br/>Produced by: Best Buy',
          image: '/assets/thumbs/SupportACTORS.jpg',
          url: 'https://vimeo.com/28311293',
        },
        {
          title: 'Another Saturday Night',
          text: 'Billy is sick and tired of dealing with his roommate. This time though, an idea hits him.<br/>Directed by: Joe Bandelli<br/>Produced by: Joe Bandelli & Matthew Wise',
          image: '/assets/thumbs/AnotherSaturday.jpg',
          url: 'https://vimeo.com/26654380',
        },
      ],
    },
    {
      name: 'Short Films',
      subtitle: '',
      vids: [
        {
          title: 'GONE VIRAL',
          text: 'After a group of social media influencers spend the evening without incident at an infamous haunted house, one of them returns home not realizing that something has followed him back.<br/>Directed by: Joe Bandelli<br/>Produced by: MasiMedia',
          image: '/assets/thumbs/GoneViral.jpg',
          url: 'https://vimeo.com/734848635',
        },
        {
          title: 'The Regift',
          text: "'What goes around comes around' has long been at play in the world. Admitted or denied, we 're-gift' all the time - one man's garbage is another mans treasure. <br/>Directed by: Joe Bandelli<br/>Produced by: Joe Bandelli & Debbie DeLisi",
          image: '/assets/thumbs/TheRegift.jpg',
          url: 'https://vimeo.com/202586714',
        },
        {
          title: 'Strussel Games',
          text: 'After accepting a dinner invitation to the infamous Von Struss Mansion, Baxter and Ursula Driesdorf are led through an evening filled with fear and manipulation by a mysterious man... who simply wants to play a game.<br/>Directed by: Joe Bandelli<br/>Produced by: Joe Bandelli & Matthew Wise',
          image: '/assets/thumbs/StrusselGames.jpg',
          url: 'https://vimeo.com/32337820',
        },
      ],
    },
  ],
};

export default FilmData;



// WEBPACK FOOTER //
// ./src/FilmData.js